import {
  DefaultNodeOptions,
  StringNode,
  widget,
  WidgetPlugin,
} from '@sagold/react-json-editor';

import { FormField } from '../../../components/formfield/FormField';
import { Input } from '../../../components/input/Input';
import { ReadOnlyInput } from '../../../components/readonly-input/ReadOnlyInput';
import { isNullableString, useErrorTransformation } from '../widgetUtils';

export type StringOptions = DefaultNodeOptions<{
  /** show loading indiciator */
  loading?: boolean;
  /** add clear input action */
  clearing?: boolean;
  tableLayout?: boolean;
  showTitle?: boolean;
}>;

export const StringWidget = widget<StringNode<StringOptions>, string>(
  ({ node, options, setValue }) => {
    const hasError = node.errors.length > 0;
    const isValidConst = node.schema.const != null && !hasError;

    const errors = useErrorTransformation(node.errors);

    return (
      <FormField
        widgetType="string"
        node={node}
        errors={errors}
        options={options}
        tableLayout={options.tableLayout}
      >
        {options.readOnly ? (
          <ReadOnlyInput
            label={options.title}
            value={node.value}
            tableLayout={options.tableLayout}
          />
        ) : (
          <Input
            label={options.showTitle !== false && options.title}
            placeholder={options.placeholder}
            readOnly={options.readOnly}
            required={options.required}
            disabled={options.disabled || isValidConst}
            /* Map null values to empty string for the input component, so it is
             * always considered to be in controlled state, avoiding console
             * errors for switching between uncontrolled and controlled state */
            value={node.value ?? ''}
            /** please note that we update the input on each keystroke - using
             * the controlled on-commit hook does not work out of the box */
            onChange={setValue}
            tableLayout={options.tableLayout}
            error={hasError ? node.errors[0].message : undefined}
          />
        )}
      </FormField>
    );
  }
);

export const StringWidgetPlugin: WidgetPlugin = {
  id: 'string-widget',
  use: (node) => isNullableString(node.schema.type),
  Widget: StringWidget,
};
